import { getLanguageParam } from '@sportal365/smp-widget-utils';
import { ISeasonsDetailsResponse, ISeasonsResponseDataV2, SDKOptions } from '../../types';
import { generateRequest } from '../http.service';

export const getSeasons = async ({
  dataTeam,
  dataTournament,
  sdkOptions,
}: {
  dataTeam?: string;
  dataTournament?: string;
  sdkOptions: SDKOptions;
}): Promise<ISeasonsResponseDataV2> => {
  const url = `${sdkOptions.dataConfigApiUrl}/v2/seasons`;

  const baseParams = {
    language_code: getLanguageParam(sdkOptions.dataConfigLang),
    team_id: dataTeam,
    tournament_id: dataTournament,
  };

  const requestParams = {
    ...baseParams,
  };

  return await generateRequest(url, requestParams, sdkOptions);
};

export interface IStagesProps {
  tournament_id?: string;
  season_id?: string;
}

export const getStages = async ({
  params,
  sdkOptions,
}: {
  params: IStagesProps;
  sdkOptions: SDKOptions;
}): Promise<ISeasonsDetailsResponse> => {
  const url = `${sdkOptions.dataConfigApiUrl}/v2/seasons/details`;

  const getBaseParams = () => {
    if (params.season_id) {
      return {
        season_id: params.season_id,
        language_code: getLanguageParam(sdkOptions.dataConfigLang),
      };
    }
    return {
      tournament_id: params.tournament_id,
      status: 'CURRENT',
      language_code: getLanguageParam(sdkOptions.dataConfigLang),
    };
  };

  const baseParams = getBaseParams();

  return await generateRequest(url, baseParams, sdkOptions);
};
